import { createFileRoute } from "@tanstack/react-router";
import LandingSectionPage from "@/pages/LandingSectionPage";
import { landingHead } from "@/lib/landingHead";
import { fetchHomeSsrData } from "@/lib/homeSsrData";

export const Route = createFileRoute("/en/strategy")({
  head: () => landingHead("strategy", "en"),
  loader: () => fetchHomeSsrData(),
  component: StrategyRoute,
  errorComponent: () => <LandingSectionPage section="strategy" routeLang="en" />,
  notFoundComponent: () => <LandingSectionPage section="strategy" routeLang="en" />,
});

function StrategyRoute() {
  const data = Route.useLoaderData();
  return <LandingSectionPage section="strategy" routeLang="en" modules={data.modules} />;
}
